import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';
import {useQueryClient} from '@tanstack/react-query';
import {productLineItemsQueryKeys} from '../hooks/productLineItemsQueryKeys.ts';

// Reload starts again from page 1. It used to call the list hook's fetchRecords, which
// loads the NEXT page, so with every row loaded it did nothing.
export const ReloadRecordsButton = () => {
    const queryClient = useQueryClient();

    const handleReload = () => {
        queryClient.invalidateQueries({queryKey: productLineItemsQueryKeys.all});
    };

    return (
        <Box mx='sm'>
            <ReloadButton onClick={handleReload}/>
        </Box>
    );
};
